var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_69685",
    "data-name": "Group 69685",
    transform: "translate(-38.715 -54)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_45",
    "data-name": "Ellipse 45",
    cx: 10.5,
    cy: 10.5,
    r: 10.5,
    transform: "translate(38.715 54)",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_69668",
    "data-name": "Group 69668"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_69666",
    "data-name": "Group 69666",
    transform: "translate(52.28 61.38) rotate(45)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_291",
    "data-name": "Line 291",
    y2: 8.669,
    transform: "translate(0)",
    fill: "none",
    stroke: "#be0d0d",
    strokeLinecap: "round",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_69667",
    "data-name": "Group 69667",
    transform: "translate(52.279 67.51) rotate(135)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_291-2",
    "data-name": "Line 291",
    y1: 8.669,
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#be0d0d",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.317e83a750f3954ca4a1314ac7b95cc0.svg";
export { ForwardRef as ReactComponent };